import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [isRedirecting, setIsRedirecting] = React.useState(false);

  const handleLogin = async () => {
    setIsRedirecting(true);
    await login();
    if (navigator?.vibrate) {
      navigator.vibrate(10);
    }
    navigate('/dashboard');
  };

  return (
    <div className="login-container">
      <h1>Login</h1>
      <p>Click below to sign in.</p>
      <button onClick={handleLogin} disabled={isRedirecting} className="btn-primary">
        {isRedirecting ? 'Redirecting...' : 'Login with SSO'}
      </button>
    </div>
  );
};

export default LoginPage;
